import { useState, useMemo } from "react"
import InputField from "../UIComponents/InputField"

const MapSearchDiv = ({ data, handleSetMonter }) => {
    const [query, setQuery] = useState("")
    const filteredData = useMemo(() => {
        const q = query.toLowerCase()
        if (!q) return []
        return data
            .filter((d) => {
                const nameMatch = d.organisation_namn?.toLowerCase().includes(q)
                const monterMatch = d.monternummer?.toLowerCase().includes(q)
                return nameMatch || monterMatch
            })
            .slice(0, 5)
    }, [data, query])
    const handleClick = (item) => {
        resetQuery()
        handleSetMonter(item)
    }

    const handleQuery = (e) => {
        setQuery(e.target.value)
    }
    const resetQuery = () => {
        setQuery("")
    }
    return (
        <div className="w-full max-w-lg mx-auto">
            <InputField
                classes={"opacity-85 focus:opacity-100"}
                placeholder="Hitta Monter"
                query={query}
                isSearch
                handleQuery={handleQuery}
                resetQuery={resetQuery}
            />
            {query.length > 0 && filteredData.length > 0 && (
                <div className=" mt-4 bg-color-1 fg-color-1 border dark:border-neutral-800 rounded-lg gap-2 divide-y dark:divide-neutral-800 shadow-lg">
                    {filteredData.map((item, index) => (
                        <div
                            key={index}
                            className="p-2 flex gap-2 items-start w-full overflow-hidden text-start cursor-pointer"
                            variant={"neutral-button"}
                            onClick={() => handleClick(item)}
                        >
                            <span className="bg-primary-500 text-white rounded px-1">
                                {item.monternummer}
                            </span>
                            <span className="line-clamp-1 text-ellipsis">
                                {item.organisation_namn}
                            </span>
                        </div>
                    ))}
                </div>
            )}
        </div>
    )
}

export default MapSearchDiv
